import {injectable} from 'inversify';

import type {BaseDomainFactory} from '../../../../core/domain/Base/BaseDomain.factory';

import {PaymentPlanModel} from './PaymentPlan.model';

@injectable()
export class PaymentPlanFactory
  implements BaseDomainFactory<PaymentPlanModel, PaymentPlanModel.Props>
{
  create(props: PaymentPlanModel.Props): PaymentPlanModel {
    return new PaymentPlanModel(props);
  }
}
